import { IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK } from '@semios/app-platform-values-helpers-and-types'
import moment from 'moment-timezone'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TIrrigationSchedulerStoreState } from '../irrigationSchedulerStore'
import { irrigationSchedulerStore, TDateViewEnum } from '../irrigationSchedulerStore'
import { getDateRange } from '../selectors/getDateRange'
import { getSelectedPropertyTimezoneForIrrigationScheduler } from '../selectors/getSelectedPropertyTimezoneForIrrigationScheduler'

export const setDateView = (dateView: TIrrigationSchedulerStoreState['dateView']) => {
  irrigationSchedulerStore.setState((isss) => {
    if (isss.dateView === dateView) return isss

    const timezone = getSelectedPropertyTimezoneForIrrigationScheduler(fieldAssetStore.getState(), isss)

    // switching from any multi-day view to day
    if (dateView === TDateViewEnum.DAY) {
      const dateRange = getDateRange(fieldAssetStore.getState(), isss)
      const mNow = moment.tz(timezone)

      // if today is already in view, change the dateFrom to today, otherwise keep it
      const dateFrom = mNow.isBetween(dateRange.mDateFrom, dateRange.mDateTo)
        ? mNow.clone().startOf('day').toISOString()
        : isss.dateFrom

      return {
        ...isss,
        dateView,
        dateFrom,
      }
    }

    // switching from day to any multi-day view
    if (isss.dateView === TDateViewEnum.DAY) {
      return {
        ...isss,
        dateView,
        dateFrom: moment
          .tz(isss.dateFrom, timezone)
          .day(IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK)
          .startOf('day')
          .toISOString(),
      }
    }

    // switching between multi-day views (WEEK <-> TWO_WEEKS): keep dateFrom
    return { ...isss, dateView }
  })
}
